// extracted by mini-css-extract-plugin
module.exports = {"mtoDispatch__info":"styles_mtoDispatch__info__t_hbH","mtoDispatch__title":"styles_mtoDispatch__title__45Rsk"};